import { StoreBaseHandler } from "../../../../infrastructure/base-handlers";
import { setDiagnosticFilterValues } from "./actions";
import { SetDiagnosticFiltersValuesCommand } from "./request";

export class SetDiagnosticFilterValuesHandler extends StoreBaseHandler {
  async handle(request: SetDiagnosticFiltersValuesCommand) {
    try {
      this.store.dispatch(setDiagnosticFilterValues(request.payload.diagnostics));
    } catch (e) {
      console.error(e.message);
    }
  }
}
